require('./override.sass');

module.exports = {
  placeOrderTermsOfService: 'https://example.org',
  api: {
    url: 'https://cloud.zeyos.com/bitmosaik/remotecall/zeyos.portal.api/'
  },
  theme: 'dark',
  documentTitle: 'BIT Mosaik - Kunden Portal',
  title: `<span class="logo-blue">Kunden</span><span class="font-weight-light">Portal</span>`,
  logo: require('./src/assets/logo.png'),
  i18n: {
    messages: {
      en: {
        Deliveries: {
          num: 'Delivery no.',
          shippingRef: 'Shipping Ref.',
          trackingNum: 'Tracking No.',
        },
        Notes: {
          title: 'Documents',
          news: 'News',
        },
        Dashboard: {
          title: 'Dashboard',
          News: 'News',
          Support: 'Support',
        },
      },
      de: {
        Deliveries: {
          num: 'Lieferung Nr.',
          shippingRef: 'Sendungsref.',
          trackingNum: 'Tracking-Nr.',
        },
        Notes: {
          title: 'Documente',
          news: 'Nachrichten',
        },
        Dashboard: {
          title: 'Dashboard',
          News: 'News',
          Support: 'Ihre Ansprechpartner',
        },
      }
    }
  },
  topMenu: [],
  cart: false,
  menu: [{   
  name: 'dashboard',
  main: true,
  icon: 'dashboard',
  title: 'Dashboard.title',
  component: () => import('./src/Dashboard'),
}, {
    name: 'notes',
    icon: 'note',
    title: 'Application.notes',
    component: () => import('./src/modules/Notes'),
    props: {
      type: 'notes',
      title: 'Notes.title',
      categories: null
    }
  },{
    name: 'tickets',
    icon: 'forum',
    title: 'Application.tickets',
    component: () => import('./src/modules/Tickets'),
    props: {
      type: 'tickets',
      columns: [{
        field: "ticketnum",
        label: "Common.ticketnum",
        align: "left",
      }, {
        field: "name",
        label: "Common.name",
        align: "left",
      }, {
        field: "description",
        label: "Common.description",
        align: "left",
      }, {
        field: "status",
        label: "Common.status",
        type: "num",
        align: "right",
      }, {
        field: "duedate",
        label: "Common.duedate",
        type: "date",
        align: "right",
      }, {
        field: "date",
        label: "Common.date",
        type: "date",
        align: "right",
      }],
      datailFields: [{
        field: "name",
        label: "Common.name"
      }, {
        field: "assigneduser.name",
        label: "Common.ouragent"
      }, {
        field: "contact.name",
        label: "Common.ouragent"
      }, {
        field: "extdata.nickname",
        label: "Common.nickname"
      }],
      createButton: "support@bit-mosaik.de",
    }
  },
  {
    main: false,
    name: 'billing',
    icon: 'attach_money',
    title: 'Application.billing',
    pinProtected: false,
    component: () => import('./src/modules/Transactions'),
    props: {
      type: 'billing',
      columns: [{
        field: "transactionnum",
        label: "Invoices.invoiceNum",
      }, {
        field: "date",
        label: "Common.date",
        type: "date",
      }, {
        field: "netamount",
        label: "Common.netAmount",
        type: "num",
        align: "right",
      }, {
        field: "tax",
        label: "Common.taxAmount",
        type: "num",
        align: "right",
      }, {
        field: "total",
        label: "Common.total",
        type: "num",
        sortable: true,
        align: "right",
      }, {
        field: "status",
        label: "Common.status",
        type: "num",
        sortable: true,
        align: "right",
      }]
    }
  }]
}
